<template>
  <div class="login">
    <div class="login__top">
       <span class="login__title">
        ZALOGUJ SIĘ
      </span>
      <span class="login__close" @click="closeModal" />
    </div>
    <div class="login__form">
      <LoginModalInput type="login" placeholder="Login lub e-mail" v-model="login"/>
      <LoginModalInput type="password" placeholder="Hasło" v-model="password"/>


    </div>
    <div class="login__flex">
      <div class="flex__remember">
        <input class="flex__checkbox" name="remember" id="remember" type="checkbox" v-model="remember"/>
        <label class="flex__label" for="remember">Pamiętaj mnie</label>
      </div>
      <span class="flex__forgot" @click="forgotPass">Zapomnialeś hasła?</span>
    </div>
            <span class="login__invalid" v-if="invalid">Błędny login lub hasło.</span>

    <div class="login__buttons">
    <SelectButton buttonName="Zaloguj się" :action="logIn"/>
        <SelectButton buttonName="Rejestracja" :action="register"/>




    <button class="login__cancel" @click='closeModal'>anuluj</button>
    </div>
  </div>
</template>

<script>
import SelectButton from '@/ui/SelectButton.vue';
import LoginModalInput from '@/ui/LoginModalInput.vue';
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
    LoginModalInput
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 94%;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__buttons {
    width: 28%;
  }
  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  display: flex;
    align-items: center;

  }
  &__title {
    font-family: 'Poppins';
    color: white;
    margin-left: 1rem;

  }
  &__form {
    width: 66%;
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }

  &__flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 66%;
    font-family: "Poppins", sans-serif;
    color: #5e5a6b;
    font-style: italic;
  }
  .flex {
    &__checkbox {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
    &__remember {
      display: flex;
      align-items: center;
      font-size: 11px;
    }
    &__forgot {
      font-size: 11px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }

&__invalid {
    color: red;
        margin-top: 1rem;
  }
  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;

    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
}
</style>
